var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHatSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 81.818,
    viewBox: "0 0 100 81.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "school_FILL0_wght400_GRAD0_opsz48",
    d: "M51.886,87.818,18.932,69.75V42.477L2,33.273,51.886,6,102,33.273V69.3H95.182V37.25L84.841,42.477V69.75Zm0-35,35.8-19.545-35.8-19.2-35.568,19.2Zm0,27.273L78.023,65.659V46.568L51.886,60.545,25.75,46.341V65.659ZM52,52.818ZM51.886,61.227ZM51.886,61.227Z",
    transform: "translate(-2 -6)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatSchool);
export default __webpack_public_path__ + "static/media/hatSchool.8e5febe8cb8cf3130432647c4902e937.svg";
export { ForwardRef as ReactComponent };